import { fromJS } from "immutable";

import TYPE from "../../constants/type";

const initialState = fromJS({
  list: [],
  listById: [],
  listFiltered: [],
  listDuplicate: [],
  isFetching: false,
  isFetchingAccepted: false,
});

export default function exhibitionReducer(state = initialState, action) {
  switch (action.type) {
    case TYPE.EXHIBITION.GET_ALL_EXHIBITION_LOADING:
    case TYPE.EXHIBITION.GET_FILTERED_EXHIBITION_LOADING:
    case TYPE.EXHIBITION.GET_ALL_EXHIBITION_BY_PROFILE_ID_LOADING:
    case TYPE.EXHIBITION.INSERT_EXHIBITION_LOADING:
    case TYPE.EXHIBITION.UPDATE_EXHIBITION_LOADING:
    case TYPE.EXHIBITION.DELETE_EXHIBITION_LOADING:
    case TYPE.EXHIBITION.CHECK_DUPLICATE_EXHIBITION_LOADING:
      return state.merge({
        isFetching: true,
      });

    case TYPE.EXHIBITION.ACCEPT_EXHIBITION_LOADING:
      return state.merge({
        isFetchingAccepted: true,
      });

    case TYPE.EXHIBITION.GET_ALL_EXHIBITION_FAILURE:
    case TYPE.EXHIBITION.GET_FILTERED_EXHIBITION_FAILURE:
    case TYPE.EXHIBITION.GET_ALL_EXHIBITION_BY_PROFILE_ID_FAILURE:
    case TYPE.EXHIBITION.INSERT_EXHIBITION_FAILURE:
    case TYPE.EXHIBITION.UPDATE_EXHIBITION_FAILURE:
    case TYPE.EXHIBITION.DELETE_EXHIBITION_FAILURE:
    case TYPE.EXHIBITION.CHECK_DUPLICATE_EXHIBITION_FAILURE:
      return state.merge({
        isFetching: false,
      });

    case TYPE.EXHIBITION.ACCEPT_EXHIBITION_FAILURE:
      return state.merge({
        isFetchingAccepted: false,
      });

    case TYPE.EXHIBITION.GET_ALL_EXHIBITION_SUCCESS:
      return state.merge({
        list: action.payload || [],
        isFetching: false,
      });

    case TYPE.EXHIBITION.GET_FILTERED_EXHIBITION_SUCCESS:
      return state.merge({
        listFiltered: action.payload || [],
        isFetching: false,
      });

    case TYPE.EXHIBITION.GET_ALL_EXHIBITION_BY_PROFILE_ID_SUCCESS:
      return state.merge({
        listById: [...action.payload],
        isFetching: false,
      });

    case TYPE.EXHIBITION.INSERT_EXHIBITION_SUCCESS: {
      const newlistById = state.get("listById");
      const index = action.payload.exhibitionProfile.findIndex((e) => e.profileId === action.id);
      if (index >= 0) newlistById.push({ exhibition: action.payload });
      return state.merge({
        listById: [...newlistById],
        listFiltered: [...state.get("listFiltered"), { exhibition: action.payload }],
        isFetching: false,
      });
    }

    case TYPE.EXHIBITION.UPDATE_EXHIBITION_SUCCESS: {
      const newList = state.get("listFiltered");
      const index = newList.findIndex((e) => e.exhibition.id === action.id);
      newList.splice(index, 1, { exhibition: action.payload });

      const newList1 = state.get("listById");
      const index1 = newList1.findIndex((e) => e.exhibition.id === action.id);
      newList1.splice(index1, 1, { exhibition: action.payload });

      return state.merge({
        listFiltered: [...newList],
        listById: [...newList1],
        isFetching: false,
      });
    }

    case TYPE.EXHIBITION.DELETE_EXHIBITION_SUCCESS: {
      const newList = state.get("listFiltered");
      const index = newList.findIndex((e) => e.exhibition.id === action.id);
      if (index !== -1) newList.splice(index, 1);

      const newList1 = state.get("listById");
      const index1 = newList1.findIndex((e) => e.exhibition.id === action.id);
      if (index1 !== -1) newList1.splice(index1, 1);

      return state.merge({
        listFiltered: [...newList],
        listById: [...newList1],
        isFetching: false,
      });
    }

    case TYPE.EXHIBITION.ACCEPT_EXHIBITION_SUCCESS: {
      const newList = state.get("listById");
      const index = newList.findIndex((e) => e.exhibition.id === action.payload.id);
      const newExhibition = { ...newList[index], exhibition: action.payload };
      newList.splice(index, 1, newExhibition);

      const newList1 = state.get("listFiltered");
      const index1 = newList1.findIndex((e) => e.exhibition.id === action.payload.id);
      const newExhibition1 = { ...newList1[index1], exhibition: action.payload };
      newList1.splice(index1, 1, newExhibition1);

      return state.merge({
        listById: [...newList],
        listFiltered: [...newList1],
        isFetchingAccepted: false,
      });
    }

    case TYPE.EXHIBITION.CHECK_DUPLICATE_EXHIBITION_SUCCESS:
      return state.merge({
        listDuplicate: action.payload || [],
        isFetching: false,
      });

    default:
      return state;
  }
}

